'use strict';

var processInclude = require('./components/processInclude');

$(document).ready(function () {
    processInclude(require('./blog/blog'));
});
